import type { ICampaignTemplate } from '~/modules/campaign-template/types';

import { CAMPAIGN_STATUS, CAMPAIGN_TYPE } from '~/constants/campaign';
import { useCampaignGroupStore } from '~/modules/campaign-group';
import { removeDuplicates } from '~/utils/removeDuplicates';
import { useMemo } from 'react';

export const useCGTemplateListing = () => {
  const dataCampaignGroups = useCampaignGroupStore((state) => state.campaignGroups || []);

  const data = useMemo(() => {
    const listCGTemplates = dataCampaignGroups.filter(
      (item) => item.type === CAMPAIGN_TYPE.TEMPLATE_BUNDLE,
    );

    const dataUnique = removeDuplicates(listCGTemplates, ['id']);
    return dataUnique.map((group) => ({
      ...group,
      name: group.title || '',
    })) as ICampaignTemplate[];
  }, [dataCampaignGroups]);

  const dataActive = useMemo(() => {
    const listCGTemplates = data.filter((item) => item.status !== CAMPAIGN_STATUS.DRAFT);
    return listCGTemplates;
  }, [data]);

  return {
    data,
    dataActive,
  };
};
